import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/headers/PageHeader';
import { IonContent } from '@ionic/react';
import GiftCardsOrderDetailsScreen, {
  Props,
} from '../../../../pages/gift-cards/order-details/GiftCardsOrderDetailsScreen';

const GiftCardsOrderDetailsPage: FC<Props> = (props) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:GiftCardsOrderDetailsPage' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="safe-area-bottom">
        <GiftCardsOrderDetailsScreen {...props} />
      </IonContent>
    </>
  );
};

export default GiftCardsOrderDetailsPage;
